{
	"name": "company-finder-app",
	"private": true,
	"type": "module",
	"module": "src/index.ts",
	"version": "6.3.78-927",
	"scripts": {
		"start-dev": "TS_NODE_PROJECT=/workspace/company-finder-app/tsconfig.json NODE_OPTIONS='--loader ts-node/esm -r tsconfig-paths/register' ng serve --host 0.0.0.0 --proxy-config proxy.conf.json",
		"build": "TS_NODE_PROJECT=./tsconfig.json NODE_OPTIONS='--loader ts-node/esm -r tsconfig-paths/register' ng build"
	},
	"browser": {
		"fs": false,
		"path": false,
		"os": false
	},
	"dependencies": {
		"@angular/animations": "^20.1.3",
		"@angular/cdk": "^20.1.3",
		"@angular/common": "^20.1.3",
		"@angular/compiler": "^20.1.3",
		"@angular/core": "^20.1.3",
		"@angular/forms": "^20.1.3",
		"@angular/platform-browser": "^20.1.3",
		"@angular/platform-browser-dynamic": "^20.1.3",
		"@angular/router": "^20.1.3",
		"@auth0/angular-jwt": "^5.2.0",
		"@iframe-resizer/child": "^5.3.1",
		"core-js": "^3.4.8",
		"d3": "^7.9.0",
		"escape-string-regexp": "^5.0.0",
		"lodash-es": "^4.17.21",
		"mapbox-gl": "^3.4.0",
		"ngx-pagination": "^6.0.3",
		"ngx-toastr": "^19.0.0",
		"ngx-ui-scroll": "^3.2.1",
		"rxjs": "^7.8.1",
		"swiper": "^11.2.1",
		"ts-loader": "^9.5.2",
		"tslib": "^2.8.1",
		"uuid": "^11.0.5",
		"vscroll": "^1.6.1",
		"zone.js": "~0.15.0"
	},
	"devDependencies": {
		"@angular-builders/custom-webpack": "^20.0.0",
		"@angular-devkit/core": "^20.1.3",
		"@angular/build": "^20.1.2",
		"@angular/cli": "^20.1.3",
		"@angular/compiler-cli": "^20.1.3",
		"@angular/language-service": "^20.1.3",
		"@tsed/barrels": "^6.1.11",
		"@types/lodash": "^4.14.149",
		"@types/mapbox-gl": "3.4",
		"@types/node": "^22.14.0",
		"ts-node": "^10.9.2",
		"typescript": "^5.8.3"
	}
}
